import axios from 'axios';
import { header } from './header.encry';

const API_URL = process.env.REACT_APP_PEGASUS_API_URL;

export const fetchProductAddons = async () => {
  const res = await axios.get(`${API_URL}/productAddons`, header());
  return res.data;
};

export const fetchProductAddon = async (id) => {
  const res = await axios.get(`${API_URL}/productAddons/${id}`, header());
  return res.data;
};

export const createProductAddon = async (data) => {
  const res = await axios.post(`${API_URL}/productAddons`, data, header());
  return res.data;
};

export const updateProductAddon = async (id, data) => {
  const res = await axios.put(`${API_URL}/productAddons/${id}`, data, header());
  return res.data;
};

export const deleteProductAddon = async (id) => {
  await axios.delete(`${API_URL}/productAddons/${id}`, header());
};

export default {
  fetchProductAddons,
  fetchProductAddon,
  createProductAddon,
  updateProductAddon,
  deleteProductAddon,
};
